import {Avatar, Modal, Switch} from 'antd'
import {
    course_getAvailSubjectsForCourse_Api,
    course_linkSubjectToCourse_Api,
    course_unlinkSubjectToCourse_Api,
} from 'apis'
import {getId} from 'apis/model/base'
import {showConfirm} from 'components/Feed/TimeLineFeed'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo, useState} from 'react'
import {BsGrid, BsUiRadiosGrid} from 'react-icons/bs'
import {NullAsDefault, pagerControls, renderSelf} from 'views/Shared'
import {renderCourseSubject} from '../../../Workspace/Course/functions/renderCourseSubject'
import EntityList from '../../EntityList'
import {notifyOnError} from '../../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {bindQueryParam} from '../../functions/routerHelper'
import {createNumberControlledInput} from "../../factory/createFormField";
import {Formik} from "formik";
import {renderIf, shallowDiff} from "../../../Shared";
import {FormActionGroups} from "../../../../components/form/FormActionBar";
import FieldsFactory from "../../../../components/form/FieldsFactory";
import {course_editSubjectParamInCourse_Api} from "../../../../apis";
import {PiFadersFill} from "react-icons/pi";
import Translate from "../../../../modules/local/Translate";
import LookupField from "../../../../components/LookupField";
import {createValue} from "../../../../components/form/utils";
import {getType} from "../../../../apis/model/base";
import TooltipApp from "components/TooltipApp";
import {compose, mapProps} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import getTitle from "../../../../helpers/getTitle";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const subject_actions = {
    link: {label: 'selected', value: 1, action: 'active'},
    unLink: {label: 'no', value: 0, action: 'inactive'},
}

function confirmAction(params) {
    const {title, content, Icon = NullAsDefault} = params ?? {}
    showConfirm({
        icon: Icon,
        okButtonProps: {
            type: 'primary',
            className: 'rounded-lg no-shadow no-text-shadow no-border',
        },
        cancelButtonProps: {
            type: 'default',
            className: 'rounded-lg no-shadow no-text-shadow no-border',
        },
        title: {title},
        content: {content},
        ...(params ?? {}),
    })
}


export const formSchema = {
    is_mandatory: {
        inline: true,
        className: 'flex justify-end',
        itemClassNames: "flex w-full",
        description: 'is mandatory subject description',
        children: [
            {
                name: 'is_mandatory',
                label: 'is mandatory subject',
                className: 'w-full flex items-center gap-3 flex-row',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate: t}) => ({
                        name,
                        checked: !!value,
                        style: {width: 'auto'},
                        checkedChildren: t('yes'),
                        onChange: (value) => {
                            onChange(createValue(name, Number(value ?? 0)))
                        },
                    }))
                )(Switch),
            },
        ],
    },
    number_of_sessions__credits: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'number of sessions',
                name: 'number_of_sessions',
                component: createNumberControlledInput({
                    placeholder: 'ex : 30',
                    inputMode: 'number',
                }),
            },
            {
                label: 'number of credits',
                name: 'number_of_credits',
                component: createNumberControlledInput({
                    placeholder: 'ex : 30',
                    inputMode: 'number',
                }),
            },
        ],
    },
    // number_of_credits: {
    //   title: 'number of credits',
    //   children: [
    //     {
    //       name: 'number_of_credits',
    //       component: createNumberControlledInput({
    //         placeholder: 'number of credits',
    //       }),
    //     },
    //   ],
    // },

    cond: {
        inline: true,
        title: 'passing requirement',
        description: 'subject completion requirements',
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                name: 'passed_score',
                component: createNumberControlledInput({
                    placeholder: 'passed score',
                    defaultValue: 5,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('score')}`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
            {
                name: 'passed_attendance_percentage',
                component: createNumberControlledInput({
                    placeholder: 'passed attendance percentage',
                    defaultValue: 60,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('cc_percent')} (%)`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
        ],
    },
    cond1: {
        inline: true,
        title: 'passing requirement (2nd)',
        description: 'subject completion requirements (optional)',
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                name: 'passed_score_1',
                component: createNumberControlledInput({
                    placeholder: 'passed score',
                    defaultValue: 0,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('score')}`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
            {
                name: 'passed_attendance_percentage_1',
                component: createNumberControlledInput({
                    placeholder: 'passed attendance percentage',
                    defaultValue: 0,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('cc_percent')} (%)`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
        ],
    },
    cond2: {
        inline: true,
        title: 'passing requirement (3rd)',
        description: 'subject completion requirements (optional)',
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                name: 'passed_score_2',
                component: createNumberControlledInput({
                    placeholder: 'passed score',
                    defaultValue: 0,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('score')}`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
            {
                name: 'passed_attendance_percentage_2',
                component: createNumberControlledInput({
                    placeholder: 'passed attendance percentage',
                    defaultValue: 0,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('cc_percent')} (%)`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
        ],
    },
    passed_score: {
        title: 'passed score',
        children: [
            {
                name: 'passed_score',
                component: createNumberControlledInput({
                    placeholder: 'passed score',
                    defaultValue: 5,
                }),
            },
        ],
    },
    passed_attendance_percentage: {
        title: 'passed attendance percentage',
        children: [
            {
                name: 'passed_attendance_percentage',
                component: createNumberControlledInput({
                    placeholder: 'passed attendance percentage',
                    defaultValue: 60,
                    addonBefore: (
                        <Translate>
                            {(t) => (
                                <span className="font-medium text-sm text-color-400 italic">
                      {`${t('percent')} (%)`}
                    </span>
                            )}
                        </Translate>
                    ),
                }),
            },
        ],
    },
    group_name: {
        title: 'group name',
        children: [
            {
                name: 'group_name',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    const owner = _.get(values, 'subject.owner', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={
                                        values?.group_name
                                    }
                                    apiPath={`/lookup/${getType(owner)}/${getId(owner)}/field/course_subject_group_name/gets`}
                                    name={name}
                                    placeholder={t('choose or create')}
                                    handleChange={(e) => {
                                        onChange(
                                            createValue('group_name', e.target.value)
                                        )
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
}


export const SubjectInCourseEditForm = ({
                                            onCancel = NullAsDefault,
                                            onSubmit = NullAsDefault,
                                            initialValues = {},
                                        }) => {
    const t = useTranslate()

    const [current, setCurrent] = useState('overview')

    const _initialValues = useMemo(() => {
        const {...rest} = initialValues ?? {}
        return {
            is_mandatory: 0,
            ...rest
        }
    }, [initialValues])

    const validate = (values) => {
        let errors = {}

        const {number_of_sessions, number_of_credits, passed_score, passed_attendance_percentage} = values ?? {}

        if (!number_of_sessions) {
            errors.number_of_sessions = t('required field')
        }
        if (!number_of_credits) {
            errors.number_of_credits = t('required field')
        }
        if (!passed_score) {
            errors.passed_score = t('required field')
        }
        if (!passed_attendance_percentage) {
            errors.passed_attendance_percentage = t('required field')
        }

        return errors
    }


    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {...rest} = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest
                        },
                        _.isUndefined
                    )
                )
            }}>
            <React.Fragment>
                <div className="mb-4 p-3 flex flex-col border border-color-50 shadow-md rounded-lg">
                    <div className="mb-3 pb-2 border-b border-primary-200 font-bold text-lg text-primary tracking-wide">
                        {getTitle(initialValues?.subject)}
                    </div>
                    <div className="text-sm text-color-300 italic tracking-wider">
                        {`* ${t('update course subject description')}`}
                    </div>
                </div>
                <ActionModalWrapper
                    action={
                        <FormActionGroups
                            submitProps={{
                                label: 'save',
                            }}
                        />
                    }>
                    <div className="mt-3 p-3 border-l-4 border-color-100 shadow-items rounded-xl flex flex-col gap-2">
                        <div className="font-bold text-base text-gray-700 uppercase tracking-wide leading-tight">
                            {t('classifying content')}
                        </div>
                        <FieldsFactory
                            formSchema={[
                                formSchema.group_name,
                            ]}
                        />
                    </div>
                    <div className="pt-3 flex flex-col gap-6">
                        <div className="p-3 border-l-4 border-blue-400 shadow-items rounded-xl flex flex-col gap-3">
                            <div className="font-bold text-base text-gray-700 uppercase tracking-wide leading-tight">
                                {t('the classification attributes of academic points')}
                            </div>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.is_mandatory,
                                    formSchema.number_of_sessions__credits,
                                ]}
                            />
                        </div>
                        <div className="p-3 border-l-4 border-green-500 shadow-items rounded-xl flex flex-col gap-3">
                            <div className="font-bold text-base text-gray-700 uppercase tracking-wide leading-tight">
                                {t('subject completion requirements')}
                            </div>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.cond,
                                    formSchema.cond1,
                                    formSchema.cond2,
                                ]}
                            />
                        </div>
                    </div>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

export const CourseSubjectList = ({
                                      item,
                                      header = null,
                                      controls = pagerControls,
                                      renderFooter = renderSelf,
                                  }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const [refreshToken, setRefreshToken] = useState()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }


    const apiInfo = course_getAvailSubjectsForCourse_Api

    const {keyword, component: search_widget} = controls?.search ?? {}

    const course_id = getId(item)

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', course_id),
                JSON.stringify(keyword),
                refreshToken,
            ].join(','),
        [course_id, keyword, refreshToken]
    )

    const onError = notifyOnError(t)

    const refresh = () => {
        setRefreshToken(Date.now())
    }

    const {handleAsyncAction: addSubject} = useAsyncAction({
        apiInfo: course_linkSubjectToCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            refresh()
        },
    })

    const {handleAsyncAction: removeSubject} = useAsyncAction({
        apiInfo: course_unlinkSubjectToCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            refresh()
        },
    })

    const {handleAsyncAction: editSubjectInfo} = useAsyncAction({
        apiInfo: course_editSubjectParamInCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            refresh()
            onCancel()
        },
    })

    const handleAction = (action, params) => {
        switch (action) {
            case "EDIT_SUBJECT_INFO_IN_COURSE":
                setAction({type: action, value: params})
                break
            case subject_actions.link.action:
                const {course, subject} = params ?? {}
                confirmAction({
                    Icon: <BsUiRadiosGrid style={{color: '#48bb78'}} className="anticon"/>,
                    okText: t('choose'),
                    cancelText: t('ignore'),
                    title: (
                        <span className="font-bold text-color-000">{t('choose subject')}</span>
                    ),
                    content: (
                        <span className="text-color-500 italic">
              {t('are you sure you want to choose this course class')}
            </span>
                    ),
                    onOk: () => {
                        addSubject(
                            {},
                            {course_id: getId(course), subject_id: getId(subject)}
                        )
                    },
                })
                break
            case subject_actions.unLink.action:
                const course_subject_id = params?.id
                if (course_subject_id) {
                    confirmAction({
                        Icon: <BsGrid style={{color: 'var(--color-primary-300)'}} className="anticon"/>,
                        okText: t('sure'),
                        cancelText: t('ignore'),
                        title: (
                            <span className="font-bold text-color-000">{t('deselect subjects')}</span>
                        ),
                        content: (
                            <span className="text-color-500 italic">
                {t('are you sure you want to deselect subjects of class')}
              </span>
                        ),
                        onOk: () => {
                            removeSubject({}, {id: course_subject_id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderActions = (item) => {
        return (
            <div className="flex flex-center gap-x-3">
                {renderIf(
                    item?.is_linked,
                    <TooltipApp
                        title={t('update subject info for course')}
                        placement="left"
                        style={{body: {
                                minHeight: 30,
                                fontSize: 12,
                                fontStyle: 'italic',
                            }}}>
                        <Avatar
                            size={26}
                            onClick={() => {
                                if (handleAction) {
                                    handleAction("EDIT_SUBJECT_INFO_IN_COURSE", item);
                                }
                            }}
                            icon={<PiFadersFill size={16} className="text-secondary-600 hover:text-white"/>}
                            className="flex flex-center bg-secondary-100 hover:bg-secondary-600 cursor-pointer"
                        />
                    </TooltipApp>
                )}
                <Switch
                    size={isLg ? 'default' : 'small'}
                    // className="custom-switch-xs"
                    checked={Number(!!item?.is_linked)}
                    onChange={(value) => {
                        const current = _.find(subject_actions, {
                            value: Number(value),
                        })
                        handleAction(current?.action, item)
                    }}
                />
            </div>
        )
    }

    const modal = useMemo(() => {
        let title
        let Content = NullAsDefault
        let params = {title: undefined}
        let modal_params = {}
        let Wrapper = ({children}) => children({item: {}});
        switch (action?.type) {
            case "EDIT_SUBJECT_INFO_IN_COURSE":
                title = (
                    <div className="uppercase text-center font-bold text-color-000 tracking-wide">
                        {t('update subject info for course')}
                    </div>
                )
                params = {
                    initialValues: action?.value,
                    onCancel,
                    onSubmit: (values) => {
                        editSubjectInfo(
                            values,
                            {
                                id: action?.value?.id,
                            }
                        )
                    }
                }
                modal_params = {
                    width: 600,
                }
                Content = SubjectInCourseEditForm
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{item}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action])

    return (
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="px-3 flex flex-col gap-4 flex-1">
                {search_widget}
                <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                    <EntityList
                        key={refreshKey}
                        apiInfo={apiInfo}
                        values={{keyword}}
                        refreshKey={refreshKey}
                        RenderEntity={React.Fragment}
                        query={bindQueryParam({id: course_id})}
                        renderItem={renderCourseSubject({renderActions, handleAction})}
                    />
                </div>
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}

